import { toggleMark } from 'common/Prose/Toolbar/components/Format/components/utils/toggleMark'
import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { computed } from 'mobx'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export function useSuperscriptToggle(view: EditorView): ButtonHook {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const hasCodeBlock = computed(() => almanacState.activeNodes.has(schema.nodes.code_block)).get()

  const hasSuperscript = computed(() => almanacState.activeMarks.has(schema.marks.superscript)).get()

  const handleClick = () => {
    const command = toggleMark(schema.marks.superscript)
    command(view.state, view.dispatch)
    view.focus()
  }

  return { active: hasSuperscript, handleClick: handleClick, disabled: hasCodeBlock }
}
